import { render, staticRenderFns } from "./CustomerFavoriteList.vue?vue&type=template&id=69ab99bf"
import script from "./CustomerFavoriteList.vue?vue&type=script&lang=js"
export * from "./CustomerFavoriteList.vue?vue&type=script&lang=js"
import style0 from "./CustomerFavoriteList.vue?vue&type=style&index=0&id=69ab99bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports